import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { CommonLoaderBackdropSx } from "../assets/styles/commonSx";

const PageLoader = ({ children }) => {
  return (
    <Backdrop sx={CommonLoaderBackdropSx} open={true}>
      <CircularProgress color="inherit" />
      <div
        style={{
          marginTop: "73px",
          marginLeft: "-60px",
        }}
      >
        {children}
      </div>
    </Backdrop>
  );
};

export default PageLoader;
